<template>
  <v-dialog
    v-model="showModal"
    persistent
    max-width="800px"
    style="min-width: 800px"
    @keydown.enter.prevent="submit()"
    @keydown.esc.prevent="cancel()"
  >
    <el-overlay-loading :loading="modalloading" />
    <v-card class="modalCard">
      <v-card-title class="modalTitle pt-2 pb-1" v-if="!modalloading">
        <span>Tikrinti asmenį</span>
        <v-spacer></v-spacer>
        <v-btn icon @click.native.stop="closeModal()">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <!-- search  -->
        <v-card outlined>
          <v-card-text>
            <v-row>
              <!-- foreigner  -->
              <template>
                <v-col class="pb-0" cols="12" md="6">
                  <el-text-field
                    required
                    label="Vardas"
                    v-model="formData.name"
                    validateKey="UZS_name"
                    key="UZS_name"
                  />
                </v-col>
                <v-col class="pb-0" cols="12" md="6">
                  <el-text-field
                    required
                    label="Pavardė"
                    v-model="formData.lastname"
                    validateKey="UZS_lastname"
                    key="UZS_lastname"
                  />
                </v-col>
                <v-col class="pb-0" cols="12" md="6">
                    <el-date-picker
                    required
                    pastDates
                    label="Gimimo data"
                    v-model="formData.birth_date"
                    validateKey="birth_date"
                    key="birth_date"
                    />
                </v-col>
                <v-col class="pb-0" cols="12" md="6">
                    <el-autocomplete style="z-index: 1000"
                    :items="classifiers.country"
                    itemvalue="value"
                    itemtext="text"
                    label="Valstybė"
                    v-model="formData.country"
                    validateKey="uzs_country_pp"
                    key="uzs_country_pp"
                    />
                </v-col>
                <v-col class="pb-0" cols="12" md="12">
                    <el-text-field
                    label="Fizinio asmens identifikavimo kodas užsienio valstybėje"
                    v-model="formData.foreigner_code"
                    validateKey="iltu_code"
                    />
                </v-col>
              </template>

              <v-col class="pb-2 pt-0" cols="12" md="12">
                <el-button
                  title="Tikrinti asmenį asmenyse"
                  small
                  icon="ieškoti"
                  class="mr-2"
                  :loading="loading"
                  @click.native.stop="search()"
                  color="primary"
                />
                <el-button
                  title="Išvalyti"
                  icon="išvalyti"
                  small
                  :loading="loading"
                  @click.native="clear()"
                  color="secondary"
                />
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
        <!-- persons table data -->
        <v-card v-if="showPersonsTable" class="mt-4" outlined>
          <v-card-text>
            <v-row>
              <v-col cols="12" md="12">
                <v-simple-table dense>
                  <thead>
                    <tr>
                      <th>AMN ID (Tipas)</th>
                      <th>Vardas, Pavardė</th>
                      <th style="min-width: 100px;">Gimimo data</th>
                      <th>Fizinio asmens identifikavimo kodas užsienio valstybėje</th>
                      <th>Valstybė</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="person in personsTableData" :key="person.amn_id">
                      <td>{{ person.amn_id }} {{ person.amnt_type }}</td>
                      <td>{{ person.fullname }}</td>
                      <td>{{ person.birth_date }}</td>
                      <td>{{ person.foreigner_code }}</td>
                      <td>{{ person.country_name }}</td>
                      <td>
                        <el-button
                          small
                          title="Pridėti"
                          icon="pridėtiAsmenį"
                          :loading="loading"
                          @click.native="addDataFromTable(person)"
                          color="primary"
                        />
                      </td>
                    </tr>
                  </tbody>
                </v-simple-table>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
        <v-col cols="12" v-if="stillAdd">Asmenyse asmuo nerastas. Ar norite įrašyti asmenį į ASMENYS?<br>Jei taip, spauskite mygtuką [Įrašyti asmenį į ASMENYS]</v-col>
        <v-card-actions class="modalActions justify-end" elevation="5">
          <el-button
            title="Įrašyti asmenį į asmenys"
            :loading="loading"
            @click.native="addPersonToAsmenys()"
            color="primary"
          />
        </v-card-actions>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'FixPersonForm',

  props: {
    person: [Object, Array],
    value: Boolean,
    modalType: String,
    mandate: Boolean,
    journalData: Boolean,
  },
  $_veeValidate: {
    validator: 'new',
  },

  data() {
    return {
      stillAdd: false,
      formData: {},
      classifiers: {},
      personData: {},
      personsTableData: [],
      personUzsData: {},
      searchBy: null,
      loading: false,
    }
  },
  computed: {
    isLocal() {
      return process.env.VUE_APP_LOCAL === 'local'
    },
    showpersonData() {
      return this.personData && Object.keys(this.personData).length > 0
    },
    showPersonsTable() {
      return this.personsTableData && this.personsTableData.length > 0
    },
    showModal: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
  },

  created() {
    this.getClassifiers()
    this.formData.name = this.person.name
    this.formData.lastname = this.person.lastname
    this.formData.birth_date = this.person.birth_date
    this.formData.foreigner_code = this.person.foreigner_code
    this.formData.country = this.person.country
    this.formData.mandate_person_id = this.person.id
    this.modalloading = false
  },
  methods: {
    addPersonToAsmenys() {
      this.loading = true
      let formData = new FormData()
      formData.append('name', this.formData.name || '')
      formData.append('lastname', this.formData.lastname || '')
      formData.append('birth_date', this.formData.birth_date || '')
      formData.append('country', this.formData.country || '')
      formData.append('foreigner_code', this.formData.foreigner_code || '')
      if (this.journalData) {
        formData.append('journal_person_id', this.formData.mandate_person_id || '')
      } else {
        formData.append('mandate_person_id', this.formData.mandate_person_id || '')
      }

      this.$axios.post(`persons/addToAsmenys`, formData)
        .then((res) => this.$emit('addPersonData', res.data.person))
        .catch((err) => this.$root.$emit('DATA_ERROR', err))
        .finally(() => this.loading = false)
    },
    clear() {
      // clear search
      this.formData = { foreigner: false }
      this.stillAdd = false
      // clear person
      this.personData = {}
      this.$nextTick(() => {
        this.errors.clear()
        this.$nextTick(() => {
          this.$validator.reset()
        })
      })
    },
    closeModal() {
      this.showModal = false
    },
    cancel() {
      this.closeModal()
    },
    getClassifiers() {
      this.loadDefault = true
      let requiredClassifiers = { classifiers: ['country'] }
      this.$axios
        .post(`classifiers`, requiredClassifiers)
        .then((res) => {
          this.classifiers = res.data.classifiers
        })
        .catch((err) => {
          this.$root.$emit('DATA_ERROR', err)
        })
        .finally(() => {
          this.loadDefault = false
        })
    },
    addDataFromTable(person) {
        this.loading = true
        let formData = person;
        this.$axios.post(`persons/` + (this.journalData ? `updateJournalPerson` : `updateMandatePerson`) + `/${this.person.id}`, formData)
            .then((res) => this.$emit('addPersonData', res.data.person))
            .catch((err) => this.$root.$emit('DATA_ERROR', err))
            .finally(() => this.loading = false)
    //   person.amn_id = 'new_id'
    //   person.other_info = person.birth_date + ' ' + person.country_name
    //   this.$emit('addPersonData', person)
    },
    checkPerson() {
      this.loading = true
      let code = this.personData.code
      let type = this.personData.type
      let dataType = this.modalType
      this.$axios
        .post('persons/checkPerson', { code: code, type: type, dataType: dataType })
        .then(() => {
          // this.$emit('addPersonData', this.personData)
          if(this.modalType == 'blacklist'){
            this.$validator.validateAll().then((res) => {
              if (res) {
                this.$emit('addPersonData', this.personData)
              } else {
                this.$root.$emit('FORMAT_ERROR')
              }
            })
          } else {
            this.$emit('addPersonData', this.personData)
          }
        })
        .catch((err) => {
          this.$root.$emit('DATA_ERROR', err)
        })
        .finally(() => {
          this.loading = false
        })
    },
    search() {
      this.stillAdd = false;
      this.$validator.validateAll().then((res) => {
        if (res) {
          this.loading = true
          let formData = this.formData
          let url = `persons/getForeigners`
          this.$axios
            .post(url, formData)
            .then((res) => {
              this.stillAdd = false;
              this.personsTableData = res.data.persons
              this.$root.$emit('DATA_OK_CODE', '000112')
            })
            .catch((err) => {
                this.personsTableData = []
                this.stillAdd = true;
            })
            .finally(() => {
              this.loading = false
            })
        } else {
          this.$root.$emit('FORMAT_ERROR')
        }
      })
    },
  },
}
</script>
<style lang="scss" scoped></style>
